(() => {
  class FraudCheckDetailController {
    constructor(Users, $scope, ngDialog) {
      'ngInject';

      Object.assign(this, {
        Users,
        $scope,
        ngDialog,
        patient: $scope.ngDialogData.patient,
        userId: $scope.ngDialogData.userId
      });
      this.patient = $scope.ngDialogData.patient;
      this.firstBold = false;
      this.lastBold = false;
      this.zipBold = false;
      this.stateBold = false;
      this.dobBold = false;
      this.ipBold = false;
      this.phoneBold = false; // We do this to make the modal "movable or draggable"

      $scope.$on('ngDialog.opened', function (e, $dialog) {
        $(".ngdialog-theme-default.check-detail-fraud").children(".ngdialog-content").draggable({
          handle: ".patient-fraud-check-popup"
        });
      });
    }

    onCompleteCheck(resultCheck) {
      this.checkedData = {
        "false_positive": resultCheck.false_positive
      };
      this.Users.updateMatchedusers(this.userId, resultCheck.id, this.checkedData).then(() => {}).catch(() => {
        this.error = true;
      }).finally(() => {
        this.loading = false;
      });
    }

  }

  FraudCheckDetailController.$inject = ["Users", "$scope", "ngDialog"];
  angular.module('pims').controller('FraudCheckDetailController', FraudCheckDetailController);
})();